import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24bb5376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LoadingMask" }

import { reactive } from 'vue';
/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingMask',
  props: {
    text: {},
    color: {},
    fontSize: {},
    iconSize: {}
  },
  setup(__props: any) {

const props = __props;


const { text, color, fontSize, iconSize } = reactive(props);

const textStyle = reactive<any>({
    color: color ? color + 'px' : '',
    fontSize: fontSize ? fontSize + 'px' : '',
})
const loadingIcon = reactive<any>({
    borderTopColor: color ? color : '',
    width: iconSize ? iconSize + 'px' : '',
    height: iconSize ? iconSize + 'px' : '',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "text",
      style: _normalizeStyle(textStyle)
    }, _toDisplayString(_unref(text)), 5),
    _createElementVNode("div", {
      class: "loading-icon",
      style: _normalizeStyle(loadingIcon)
    }, null, 4)
  ]))
}
}

})